import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

const cardColors = [
  'bg-accent-100/60',
  'bg-secondary-100/60',
  'bg-background-200/70',
  'bg-primary-100/60',
  'bg-accent-100/60',
  'bg-secondary-100/60',
  'bg-background-200/70',
  'bg-primary-100/60',
  'bg-accent-100/60',
  'bg-secondary-100/60',
  'bg-background-200/70',
  'bg-primary-100/60',
  'bg-accent-100/60',
  'bg-secondary-100/60',
];

export default function CategorySection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Navegue por Categoria
          </p>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-950 mb-3 leading-tight">
            Explore Nossa
          </h2>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading italic text-foreground-700 leading-tight" style={{ fontFamily: 'Pacifico, cursive' }}>
            Coleção Completa
          </h2>

          <div ref={dropdownRef} className="relative inline-block mt-8">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-3 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer mx-auto"
            >
              <span>Selecionar Categoria</span>
              <i className={`text-base w-4 h-4 flex items-center justify-center ${dropdownOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
            </button>

            {dropdownOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-80 bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden max-h-96 overflow-y-auto z-20">
                {categories.map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
                    onClick={() => setDropdownOpen(false)}
                  >
                    <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                      <img src={cat.thumbUrl} alt={cat.namePt} className="w-full h-full object-cover" />
                    </div>
                    <span className="flex-1 whitespace-nowrap font-medium">{cat.namePt}</span>
                    <span className="text-foreground-400 text-xs">({cat.name})</span>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden cursor-pointer transition-transform duration-300 hover:-translate-y-1"
            >
              <div className={`relative aspect-[3/4] ${cardColors[index % cardColors.length]}`}>
                <img
                  src={cat.imageUrl}
                  alt={cat.namePt}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
              <div className="bg-background-50 py-3 px-3">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {cat.namePt}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{cat.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}